export type StudentProfileScreen = 'view' | 'edit' | 'pending' | 'changes';

export function studentProfileScreen(
  status: string,
  editing: boolean,
  peekView: boolean,
): StudentProfileScreen {
  if (editing) return 'edit';
  if (peekView) return 'view';
  if (status === 'changes_requested' || status === 'rejected') return 'changes';
  if (status === 'pending_review') return 'pending';
  return 'view';
}

export function studentStatusChip(status: string): string | null {
  if (status === 'approved') return 'Одобрен';
  if (status === 'pending_review') return 'На проверке';
  if (status === 'changes_requested' || status === 'rejected') return 'Нужны изменения';
  return null;
}

export function studentParticipantLabel(type?: string | null): string {
  if (type === 'parent') return 'Я родитель';
  return 'Ученик';
}

if (studentProfileScreen('pending_review', false, false) !== 'pending') {
  throw new Error('pending_review must open the pending screen');
}
if (studentProfileScreen('changes_requested', false, false) !== 'changes') {
  throw new Error('changes_requested must open the moderator screen');
}
if (studentProfileScreen('approved', true, false) !== 'edit') {
  throw new Error('edit flag must win over status');
}
if (studentProfileScreen('pending_review', false, true) !== 'view') {
  throw new Error('peek view must show the profile card');
}
if (studentStatusChip('approved') !== 'Одобрен') {
  throw new Error('approved chip label');
}
